import { ReactComponent as EmptyPanelDroneIcon } from '@assets/components/panel/notification/empty-panel-drone-icon.svg';
import { IcPhone } from '@assets/icons/40x40';
import { For, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { getPilotName } from '@utils/utm/pilot.utils';
import { FormattedMessage } from 'react-intl';

import { Pilot } from '@/types/utm/pilot.types';

type Props = {
  pilots: Pilot[];
};

export default function FlightPlanPilots({ pilots }: Readonly<Props>) {
  return pilots.length === 0 ? (
    <VStack width="100%" height={375} paddingY="67px">
      <EmptyPanelDroneIcon />
      <Text textStyle="md" color="neutral.200">
        <FormattedMessage id="flightPlanInfos.tab.pilots.empty" />
      </Text>
    </VStack>
  ) : (
    <VStack width="100%" gap={0.25} overflow="hidden" overflowY="auto" className="map-panel-scrollbar">
      <For each={pilots}>
        {(pilot) => (
          <HStack
            key={pilot.code}
            width="100%"
            backgroundColor="neutral.800"
            padding={4}
            justifyContent="space-between"
          >
            <HStack gap={1.5}>
              <Text>{getPilotName(pilot)}</Text>
            </HStack>
            <HStack gap={1.5}>
              <Icon as={IcPhone} boxSize="24px" color="neutral.300" />
              <Text textStyle="lg">{pilot.phoneNumber}</Text>
            </HStack>
          </HStack>
        )}
      </For>
    </VStack>
  );
}
